import type { Count } from '../../../api/crashes'

/** A breakdown (top 20) as label and count rows. */
export function CountList({ title, counts }: { title: string; counts: Count[] }) {
	return (
		<div className="stack" style={{ gap: '0.2rem' }}>
			<h3 style={{ margin: 0 }}>{title}</h3>
			{counts.length ? (
				counts.map((c) => (
					<div key={c.label} className="row small" style={{ justifyContent: 'space-between' }}>
						<span>{c.label}</span>
						<strong>{c.count}</strong>
					</div>
				))
			) : (
				<span className="muted small">None</span>
			)}
		</div>
	)
}
